import { addQueryString } from 'helpers/url'
import { log } from 'logger'
import { mockWalletHistory, mockWalletHistoryResponse, mockWalletInfo } from 'mock/activities-mock'
import { WalletDataResponse } from 'models/http'
import { SuccessResponse, WalletData, WalletInfo } from 'models/user'
import { apiClient } from './client'
import { returnMock } from './mock'

export async function GetWalletHistory(
  isMockUpEnabled: boolean,
  person_id: string,
  page: number,
): Promise<WalletDataResponse> {
  let url = `/activities`
  let queryParams: { [key: string]: string | number } = { person_id, page }

  url = addQueryString(url, queryParams)

  log('getting wallet history', { url })
  if (isMockUpEnabled) {
    return returnMock(mockWalletHistoryResponse)
  }
  return apiClient(url, {})
}

export async function GetWholeWalletHistory(isMockUpEnabled: boolean, person_id: string): Promise<WalletData[]> {
  let url = `/activities`
  let queryParams: { [key: string]: string | number } = { person_id, all_activities: 'true' }

  url = addQueryString(url, queryParams)

  log('getting whole wallet history', { url })
  if (isMockUpEnabled) {
    return returnMock(mockWalletHistory)
  }
  return apiClient(url, {})
}

export async function RefundBalance(isMockUpEnabled: boolean, person_id: string): Promise<SuccessResponse> {
  let url = `/activities/refund_balance`
  let queryParams: { [key: string]: string } = { person_id }

  url = addQueryString(url, queryParams)

  log('refunding balance', { url })
  if (isMockUpEnabled) {
    return returnMock({ message: "Successfully refunded to user's payment method" })
  }
  return apiClient(url, {
    method: 'POST',
  })
}

export async function RefundTransaction(
  isMockUpEnabled: boolean,
  person_id: string,
  transaction_id: string,
  amount: number,
  reason: string,
  other_reason?: string
): Promise<SuccessResponse> {
  let url = `/activities/refund_transaction`
  let queryParams: { [key: string]: string } = { person_id }

  url = addQueryString(url, queryParams)

  const requestBody = {
    transaction_id,
    amount: Math.round(amount * 100), // Convert dollars to cents
    reason,
    ...(other_reason && { other_reason }),
  }

  log('refunding transaction', { url, requestBody })
  if (isMockUpEnabled) {
    return returnMock({ message: "Successfully refunded transaction" })
  }
  return apiClient(url, {
    method: 'POST',
    body: JSON.stringify(requestBody),
  })
}

/** V3 / new wallet refund: POST /activities/wallet_refund (full/partial, subtotal/tax). Used by wallet page when ENABLE_TRANSACTION_V3 is true. */
export async function RefundTransactionWalletRefund(
  isMockUpEnabled: boolean,
  person_id: string,
  transaction_id: string,
  amount: number,
  refund_type: 'full' | 'partial',
  reason: string,
  subtotal?: number,
  tax_amount?: number,
  other_reason?: string
): Promise<SuccessResponse> {
  const url = addQueryString(`/activities/wallet_refund`, { person_id })
  const requestBody = {
    transaction_id,
    is_partial_refund: refund_type === 'partial' ? 'true' : 'false',
    ...(other_reason ? { other_reason } : { reason }),
    ...(refund_type === 'partial' && subtotal !== undefined && { refund_subtotal_cents: Math.round(subtotal * 100) }),
    ...(refund_type === 'partial' && tax_amount !== undefined && { refund_tax_cents: Math.round(tax_amount * 100) }),
  }
  log('refund transaction (wallet_refund)', { url, requestBody })
  if (isMockUpEnabled) return returnMock({ message: 'Successfully refunded transaction' })
  return apiClient(url, { method: 'POST', body: JSON.stringify(requestBody) })
}

export async function AddFundsToWallet(
  isMockUpEnabled: boolean,
  person_id: string,
  amount: number,
  reason: string,
  other_reason?: string
): Promise<SuccessResponse> {
  let url = `/activities/add_funds`
  let queryParams: { [key: string]: string } = { person_id }
  
  url = addQueryString(url, queryParams)
  
  const requestBody = {
    amount: Math.round(amount * 100), // Convert dollars to cents
    reason,
    ...(other_reason && { other_reason })
  }

  log('adding funds to wallet', { url, requestBody })
  if (isMockUpEnabled) {
    return returnMock({ message: "Successfully added funds to wallet" })
  }
  return apiClient(url, {
    method: 'POST',
    body: JSON.stringify(requestBody),
  })
}

export async function GetWalletInfo(isMockUpEnabled: boolean, person_id: string): Promise<WalletInfo> {
  let url = `/activities/wallet_info`
  let queryParams: { [key: string]: string } = { person_id }

  url = addQueryString(url, queryParams)

  log('getting wallet information', { url })
  if (isMockUpEnabled) {
    return returnMock(mockWalletInfo)
  }
  return apiClient(url, {})
}
